import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';

import { I18nModule } from '@recruitee/i18n';

import { ButtonComponent } from '../../common/button/button.module';
import { SegmentedControlModule } from '../../common/segmented-control/segmented-control.module';
import { TimeZonePickerModule } from '../time-zone-picker/time-zone-picker.module';
import { GroupComponent } from './../../common/group/group.component';
import { IconComponent } from './../../common/icon/icon.component';
import { RtUICoreOverlayModule } from './../../core/core.module';
import { TimePickerDropdownModule } from './time-picker-dropdown/time-picker-dropdown.module';
import { TimePickerBridge } from './time-picker-moment-bridge/time-picker-moment-bridge';
import { TimeData, TimePickerComponent } from './time-picker.component';

@NgModule({
  exports: [TimePickerComponent],
  imports: [
    GroupComponent,
    ButtonComponent,
    IconComponent,
    I18nModule,
    CommonModule,
    RtUICoreOverlayModule,
    TimePickerDropdownModule,
    TimeZonePickerModule,
    SegmentedControlModule,
    ReactiveFormsModule,
    TimePickerComponent,
  ],
})
export class TimePickerModule {}
export { TimePickerComponent, TimeData, TimePickerBridge };
